var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class MasterDataConstants {
  constructor() {
    // Section
    __publicField(this, "analysisConfigSection", "AnalysisConfig");
    __publicField(this, "controlTowerExperienceSection", "ControlTowerExperience");
    __publicField(this, "experimentExtensions", "ExperimentExtensions");
    __publicField(this, "experimentManagementGroup", "ExperimentManagementGroup");
    __publicField(this, "experimentTemplates", "ExperimentTemplates");
    __publicField(this, "experimentTrafficFiltersSection", "ExperimentTrafficFilters");
    __publicField(this, "flightControlSection", "flightControl");
    __publicField(this, "jobExecutionMetadataSection", "JobExecutionMetadata");
    __publicField(this, "progressionTemplates", "ProgressionTemplates");
    __publicField(this, "ticketCategories", "TicketCategories");
    __publicField(this, "systemHealthMessage", "SystemHealthMessage");
    // Permission Type
    __publicField(this, "adminPermission", "Admin");
    // Can create/clone/update/start/stop/advance experiments
    __publicField(this, "experimentPermission", "Experiment");
    // Default Values
    // Backend default value is 100. Defined here: https://experimentation.visualstudio.com/_git/Analysis%20and%20Experimentation?path=%2Fprivate%2FExpMan%2FExpControl%2FExpControl.DataModel%2FConstants.cs&version=GBmaster&line=165&lineEnd=168&lineStartColumn=1&lineEndColumn=59&lineStyle=plain
    __publicField(this, "maxFlightNameLengthDefault", 100);
    __publicField(this, "flightLengthReservedBySystemDefault", 4);
  }
}
class UiConstants {
}
__publicField(UiConstants, "emptyRepresentation", "– –");
__publicField(UiConstants, "notApplicable", "N/A");
const continuationErrorMessage = "If this error persists, please create a ticket using the button below.";
class PermissionMessages {
}
__publicField(PermissionMessages, "noWritePermissionError", "Only experimentation contributors can update and rollout this feature. For more details, see [https://aka.ms/exp/rbac](https://aka.ms/exp/rbac)");
const teamStageMessage = "This stage targets individual users or clients instead of the audience or rings where they may normally reside. Users in this team stage will not appear in scorecards in other stages.";
const studioProgression = "Studio Progression";
const userDoesNotHaveWritePermission = "You do not have write permission for this feature.";
const overrideTargetsIsDisabled = "Override targets are disabled for this experimentation group. You can enable it by setting EnableOverrideTargets to true in the admin portal FlightControl section for this experimentation group.";
const isAutoGeneratedIsolationGroup = "Custom overrides cannot be applied to pre-existing isolation groups as they may conflict with other experiments during forced assignment.";
const displayOverrideSection = "Override section is disabled for this feature.";
const MasterDataConstants$1 = new MasterDataConstants();
export {
  MasterDataConstants,
  PermissionMessages,
  UiConstants,
  continuationErrorMessage,
  MasterDataConstants$1 as default,
  displayOverrideSection,
  isAutoGeneratedIsolationGroup,
  overrideTargetsIsDisabled,
  studioProgression,
  teamStageMessage,
  userDoesNotHaveWritePermission
};
//# sourceMappingURL=FeatureDataConstants.js.map
